import {DiscardChangesProvider} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC, PropsWithChildren} from 'react';

/** Feeds every modal's discard confirmation from the app's `common:discardChanges` copy. */
export const I18nDiscardChangesProvider: FC<PropsWithChildren> = ({children}) => {
  const {t} = useTranslation('common');

  return (
    <DiscardChangesProvider
      labels={{
        title: t('discardChanges.title'),
        description: t('discardChanges.description'),
        keepEditingLabel: t('discardChanges.keepEditing'),
        discardLabel: t('discardChanges.discard')
      }}
    >
      {children}
    </DiscardChangesProvider>
  );
};
